var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99999 1C7.31345 1 7.56756 1.25411 7.56756 1.56757V9.27842L10.3824 6.46353C10.6041 6.24189 10.9635 6.24189 11.1851 6.46353C11.4068 6.68518 11.4068 7.04455 11.1851 7.2662L7.40132 11.05C7.17968 11.2716 6.82031 11.2716 6.59866 11.05L2.81488 7.2662C2.59323 7.04455 2.59323 6.68518 2.81488 6.46353C3.03653 6.24189 3.39589 6.24189 3.61754 6.46353L6.43243 9.27842V1.56757C6.43243 1.25411 6.68653 1 6.99999 1ZM0.94594 10.8378C1.2594 10.8378 1.51351 11.0919 1.51351 11.4054V12.9189C1.51351 13.4414 1.93702 13.8649 2.45945 13.8649H11.5405C12.063 13.8649 12.4865 13.4414 12.4865 12.9189V11.4054C12.4865 11.0919 12.7406 10.8378 13.054 10.8378C13.3675 10.8378 13.6216 11.0919 13.6216 11.4054V12.9189C13.6216 14.0683 12.6899 15 11.5405 15H2.45945C1.3101 15 0.378372 14.0683 0.378372 12.9189V11.4054C0.378372 11.0919 0.632481 10.8378 0.94594 10.8378Z",
    fill: "#051123",
    stroke: "#051123",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCsv);
export default __webpack_public_path__ + "static/media/download_csv.82f3f815eef27df6763542e20475aa54.svg";
export { ForwardRef as ReactComponent };